"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.pxToPt = exports.ptToPx = exports.mapCardTypeToCtaUrl = exports.mapCardTypeToCopy = exports.getImageUrl = exports.getCtaId = exports.fetchCrossSellData = exports.crossSellRequestDefaults = void 0;
require("core-js/modules/es.array.concat.js");
var _api = _interopRequireDefault(require("../http/api"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// types

// --- DATA ---
var crossSellRequestDefaults = exports.crossSellRequestDefaults = {
  active_only: true,
  has_custom_photo: undefined,
  limit: 6,
  offset: 0
};
var fetchCrossSellData = exports.fetchCrossSellData = function fetchCrossSellData() {
  var requestObj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : crossSellRequestDefaults;
  return _api.default.post("/web-api/v1/paper-cross-sell", requestObj).then(function (res) {
    return res;
  }).catch(function (err) {
    // eslint-disable-next-line no-console
    console.error(err);
  });
};
var mapCardTypeToCopy = exports.mapCardTypeToCopy = function mapCardTypeToCopy(cardType) {
  return cardType === 'SAVE_THE_DATE' ? 'Save the Dates' : 'Invitations';
};
var mapCardTypeToCtaUrl = exports.mapCardTypeToCtaUrl = function mapCardTypeToCtaUrl(cardType) {
  return cardType === 'SAVE_THE_DATE' ? '/wedding-planning/save-the-date/shop' : '/wedding-planning/invitations/shop';
};
var getCtaId = exports.getCtaId = function getCtaId(cardType, numTemplates) {
  var card = cardType === 'SAVE_THE_DATE' ? 'std' : 'invite';
  var number = numTemplates === 1 ? 'single' : 'multiple';
  return "edit-".concat(card, "-sample-guestlist-").concat(number);
};

// --- PREVIEW ---
var getImageUrl = exports.getImageUrl = function getImageUrl(imageId) {
  // resolve image host based on environment
  var env = typeof window !== 'undefined' && window.zola && window.zola.env || 'production';
  var hostname = '//images.zola.com';
  if (env === 'development') {
    // hostname = 'http://127.0.0.1:9100/v2/image'; // point directly at svc-image in development if pointing at development services
    hostname = '//stage-images.zola.com'; // use me if pointing services at stage (npm run dev-staging)
  } else if (env === 'staging') {
    hostname = '//stage-images.zola.com';
  }
  return "".concat(hostname, "/").concat(imageId);
};
var PX_TO_PT_RATIO = 16 / 12;
var ptToPx = exports.ptToPx = function ptToPx(pt) {
  return pt * PX_TO_PT_RATIO;
};
var pxToPt = exports.pxToPt = function pxToPt(px) {
  return px / PX_TO_PT_RATIO;
};